export default __webpack_public_path__ + "img/173daadc8b31d4bf60961d5465cada8d.png";